/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompetenceWithRelations } from './competenceWithRelations';
import { CompetenceTypesWithRelations } from './competenceTypesWithRelations';
import { RelationTypesWithRelations } from './relationTypesWithRelations';
import { CompetenceControllerFindById200ResponseAnyOf } from './competenceControllerFindById200ResponseAnyOf';


export interface CompetenceControllerFindById200Response { 
    statusCode?: number;
    success?: boolean;
    data?: CompetenceWithRelations;
    message?: string;
    error?: string;
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    name: string;
    color?: string;
    description?: string;
    competenceTypeId: string;
    competenceType?: CompetenceTypesWithRelations;
    relationTypes?: Array<RelationTypesWithRelations>;
}

